import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { BaseCellRendererComponent } from '../base-cell-renderer.component';

@UntilDestroy()
@Component({
  selector: 'y42-time-ago-cell-renderer',
  template: `<y42-time-ago [date]="state.timeAgo"></y42-time-ago>`,
})
export class TimeAgoCellRendererComponent extends BaseCellRendererComponent<Date> {
  public readonly state = connectState(this, {
    timeAgo: this.valueAsSingle$,
  });
}
